<div class="header">
	<h1 class="activity-task-snackbar-title" translate="activity-task-snackbar-title"></h1>
	<button
		class="close-btn"
		type="button"
		(click)="close()"
		[attr.aria-label]="'common_close' | translate">
		<i class="ficon-app-x"></i>
	</button>
</div>
<div class="image">
	<img src="https://staticassets.goreact.com/activity-task-announcement-image.png" alt="activity-tasks-preview">
</div>
<p class="message" translate="activity-task-snackbar-message"></p>
<div class="action-wrapper">
	<a class="tertiary-btn" href="https://support.echo360.com/hc/en-us/articles/42168061122957-GoReact-2026-Deployment-Notes-09-February" target="_blank" rel="noopener noreferrer" translate="common_learn-more"></a>
	<button class="primary-btn" (click)="close()" translate="common_dismiss"></button>
</div>
